import React, { useEffect, useMemo } from 'react'
import { useSelector, shallowEqual } from 'react-redux'

import Toast from 'multiComps/Toast'

import './index.scss'

const parseValue = (value) => {
    if (!value) return null
    if (typeof value !== 'string') return value

    try {
        return JSON.parse(value)
    } catch (err) {
        return null
    }
}

export default ({ mobile = false }) => {
    const { videoDetail } = useSelector((state) => ({
        videoDetail: state.video.videoDetail
    }), shallowEqual)
    const current = videoDetail && videoDetail.current

    const playbackUrl = useMemo(() => {
        const playbackList = parseValue(current && current.url)
        return Array.isArray(playbackList) && playbackList[0] ? playbackList[0].fileUrl : ''
    }, [current])

    const poster = useMemo(() => {
        const cover = parseValue(current && current.coverPic) || {}
        return mobile ? (cover.video_m || cover.video_pc || '') : (cover.video_pc || cover.video_m || '')
    }, [current, mobile])

    useEffect(() => {
        if (!current) {
            Toast.info('视频不存在或已删除')
        } else if (!playbackUrl) {
            Toast.info('未获取到视频地址，请刷新试试')
        }
    }, [current, playbackUrl])

    return (
        <div className="video-detail-player">
            {current && <video
                preload="metadata"
                autoPlay
                controls
                playsInline
                webkit-playsinline="true"
                src={playbackUrl}
                poster={poster}
            />}
        </div>
    )
}
